import { AUTH_BASE_URL } from "../constants/constants";
import { sendRequest } from "../utils/sendAPI";
import { getToken } from "./authApi";
import { handleResponse } from "./responseHandler";

export const getContact = async () => {
    const response = await fetch(`${AUTH_BASE_URL}/authentication/contact/get`);
    return await handleResponse(response);
};

export const updateContact = async (body) => {
    try {
        const token = getToken();
        if (!token) throw new Error("Token missing or expired");

        const res = await sendRequest({
            url: `${AUTH_BASE_URL}/authentication/contact/update`,
            method: "PATCH",
            body: body,
            token: token,
        });
        return res;
    } catch (err) {
        console.error("Error updating contact:", err);
        throw err;
    }
};